/*
 * MyPLAZA offer box (snippets/myplaza-offer.liquid).
 *
 * - Clicking a box opens its Klaviyo form: data-klaviyo-form-mobile on screens under 768px (if set),
 *   otherwise data-klaviyo-form. The bonus-only box is a link and falls back to it when no form applies.
 * - Visitors already known to Klaviyo, or who submitted one of the forms, get html.myplaza-known,
 *   which hides the 10% box and shows the points box instead.
 *
 * Uses a class on <html> rather than touching the box, because the box is re-rendered on variant change.
 */
(function () {
  if (window.myplazaOfferInit) return;
  window.myplazaOfferInit = true;

  var KNOWN_CLASS = 'myplaza-known';
  var SUBMITTED_KEY = 'myplaza_offer_submitted';
  var root = document.documentElement;

  function markKnown() {
    root.classList.add(KNOWN_CLASS);
  }

  try {
    if (window.localStorage.getItem(SUBMITTED_KEY) === '1') markKnown();
  } catch (e) {}

  // Klaviyo already knows this visitor (submitted a form, came from a Klaviyo email, etc.)
  var tries = 0;
  (function checkIdentified() {
    if (window.klaviyo && typeof window.klaviyo.isIdentified === 'function') {
      Promise.resolve(window.klaviyo.isIdentified()).then(function (known) {
        if (known) markKnown();
      }, function () {});
    } else if (tries++ < 20) {
      setTimeout(checkIdentified, 250);
    }
  })();

  var mobileQuery = window.matchMedia('(max-width: 767px)');

  var FORM_BOX = '.myplaza-offer [data-klaviyo-form], .myplaza-offer [data-klaviyo-form-mobile]';

  document.addEventListener('click', function (e) {
    var box = e.target.closest(FORM_BOX);
    if (!box) return;
    var formId = (mobileQuery.matches && box.getAttribute('data-klaviyo-form-mobile')) || box.getAttribute('data-klaviyo-form');
    if (!formId) return;
    e.preventDefault();
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', formId]);
  });

  window.addEventListener('klaviyoForms', function (e) {
    var d = e.detail || {};
    if (d.type !== 'submit') return;
    var ids = [];
    document.querySelectorAll(FORM_BOX).forEach(function (el) {
      ids.push(el.getAttribute('data-klaviyo-form'), el.getAttribute('data-klaviyo-form-mobile'));
    });
    if (ids.indexOf(d.formId) === -1) return;
    try { window.localStorage.setItem(SUBMITTED_KEY, '1'); } catch (err) {}
    markKnown();
  });
})();
